import { Typography } from '@material-ui/core';
import ReactHookTextField from 'components/ReactHookTextField';

const Base = ({ control, tableView }) => {
    return (
        <>    
            {!tableView ? <Typography variant="h6" gutterBottom>Base</Typography> : <br/>}
            <ReactHookTextField
                name='attributes.baseQty'
                type='text'
                control={control}
                label='Qty'
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.baseType'
                type='text'
                control={control}
                label='Type'
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.baseMaterial'
                type='text'
                control={control}
                label='Material'
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.baseCoating'
                type='text'
                control={control}
                label='Coating'
                style={{width: '19%', marginRight: '1%'}}
            />
        </>   
    );
};

export default Base;
